import {IPatch} from "../interfaces/requests";
import {api} from "utils/service";

export const axiosPatch = <Model>({url, data}: IPatch<Model>) => {
  return api.patch(url, data);
};
